import { useTranslation } from 'react-i18next'
import { FunctionComponent, useCallback, useState } from 'react'
import {
	BottomTextAction,
	Container,
	MissingInfoInputWrapperDiv,
} from '../styledMissingBudgetInfoComponents'
import { MissingInfoInput } from './MissingInfoInput'
import { H2Flow } from '@monthio/react-components/dist/Typography/TypographyFlow/TypographyFlow'
import { MissingInfoBudgetKey } from '../missingBudgetInfoUtils'
import { budgetEstimatesCalculatorService } from '../../BudgetOverview/budgetEstimatesCalculatorService'

export const MissingInfoInputWithButton: FunctionComponent<{
	budgetKey: MissingInfoBudgetKey
	handleNoInfoConfirmed: (result: boolean) => void
}> = ({ budgetKey, handleNoInfoConfirmed }) => {
	const { t } = useTranslation()
	const [noInfoConfirmed, setNoInfoConfirmed] = useState(false)

	const resetValue = useCallback(() => {
		budgetEstimatesCalculatorService.update(budgetKey, 0)
	}, [budgetKey])

	const handleButtonClick = () => {
		setNoInfoConfirmed((prev) => {
			handleNoInfoConfirmed?.(!prev)
			resetValue()
			return !prev
		})
	}

	const handleInputChange = () => {
		setNoInfoConfirmed(false)
		handleNoInfoConfirmed?.(false)
	}

	return (
		<Container>
			<H2Flow>
				{t(`miniBudgetFormV2-missingInfo-input-${budgetKey}-header`)}
			</H2Flow>
			<MissingInfoInputWrapperDiv>
				<MissingInfoInput
					budgetKey={budgetKey}
					noInfoConfirmed={noInfoConfirmed}
					handleChange={handleInputChange}
				/>
				<BottomTextAction
					$clicked={noInfoConfirmed}
					onClick={handleButtonClick}
				>
					{t(`miniBudgetFormV2-missingInfo-no-${budgetKey}-button`)}
				</BottomTextAction>
			</MissingInfoInputWrapperDiv>
		</Container>
	)
}

//miniBudgetFormV2-missingInfo-no-tree.expenses.housing.rent-button
//miniBudgetFormV2-missingInfo-no-tree.expenses.others.insurance-button
//miniBudgetFormV2-missingInfo-input-tree.expenses.housing.rent-header
//miniBudgetFormV2-missingInfo-input-tree.expenses.others.insurance-header
//miniBudgetFormV2-missingInfo-no-tree.income.salary-button
